import { createContext, Dispatch, SetStateAction } from 'react';

export interface UISettingsContextType {
  isIntegrationsBannerDismissed: boolean;
  setIsIntegrationsBannerDismissed?: Dispatch<SetStateAction<boolean>>;
}

export const UISettingsContext = createContext<UISettingsContextType>({
  isIntegrationsBannerDismissed: false,
  setIsIntegrationsBannerDismissed: undefined,
});
